import React from "react";

/**
 * This is the about us screen component
 * @returns {JSX.Element}
 * @constructor
 *
 * @example
 * <div>
 *     <About/>
 *     </div>
 */
export default function About(){
    return(
        <div>
            About US!
        </div>
    );
}
